/** Chaves de estado com RadioGroup sim/nao enviadas como boolean à API */
export const CAMPOS_BOOLEANOS_OBRIGATORIOS = [
  'alergicoMedicamento',
  'usoMedicamentoDiario',
  'usoCalmantes',
  'tosseCatarro',
  'doencaCardiaca',
  'marcapasso',
  'problemaPressao',
  'problemaPulmao',
  'problemaSangramento',
  'diabetes',
  'doencaInfectoContagiosa',
  'dorColuna',
  'problemaFigado',
  'problemaRim',
  'problemaSangue',
  'problemaTireoide',
  'problemaEstomago',
  'dificuldadeAbrirBoca',
  'problemaDentario',
  'usoDrogas',
  'problemaNeurologico',
  'fumante',
  'usaDentadura',
  'usaLentesContato',
  'usaPiercing',
  'proteseCapilar',
  'possibilidadeGravidez',
]

export const ROTULOS_CAMPO_BOOLEANO = {
  alergicoMedicamento: 'Alergia a medicamentos',
  usoMedicamentoDiario: 'Uso de medicamento diário',
  usoCalmantes: 'Uso de calmantes',
  tosseCatarro: 'Tosse com catarro',
  doencaCardiaca: 'Doença cardíaca',
  marcapasso: 'Marcapasso',
  problemaPressao: 'Problema de pressão',
  problemaPulmao: 'Problema pulmonar',
  problemaSangramento: 'Problema de sangramento',
  diabetes: 'Diabetes',
  doencaInfectoContagiosa: 'Doença infectocontagiosa',
  dorColuna: 'Dor ou lesão na coluna',
  problemaFigado: 'Problema no fígado',
  problemaRim: 'Problema no rim',
  problemaSangue: 'Problema no sangue',
  problemaTireoide: 'Problema na tireoide',
  problemaEstomago: 'Problema no estômago',
  dificuldadeAbrirBoca: 'Dificuldade em abrir a boca',
  problemaDentario: 'Problema dentário',
  usoDrogas: 'Uso de drogas',
  problemaNeurologico: 'Problema neurológico',
  fumante: 'Tabagismo',
  usaDentadura: 'Uso de dentadura',
  usaLentesContato: 'Lentes de contato',
  usaPiercing: 'Piercing',
  proteseCapilar: 'Prótese capilar',
  possibilidadeGravidez: 'Possibilidade de gravidez',
}

export const CAMPO_BOOLEANO_PARA_ID_SCROLL = {
  alergicoMedicamento: 'alergico-sim',
  usoMedicamentoDiario: 'medicamento-sim',
  usoCalmantes: 'calmantes-sim',
  tosseCatarro: 'tosse-sim',
  doencaCardiaca: 'cardiaco-sim',
  marcapasso: 'marcapasso-sim',
  problemaPressao: 'pressao-sim',
  problemaPulmao: 'pulmao-sim',
  problemaSangramento: 'sangramento-sim',
  diabetes: 'diabetes-sim',
  doencaInfectoContagiosa: 'infecto-sim',
  dorColuna: 'coluna-sim',
  problemaFigado: 'figado-sim',
  problemaRim: 'rim-sim',
  problemaSangue: 'sangue-sim',
  problemaTireoide: 'tireoide-sim',
  problemaEstomago: 'estomago-sim',
  dificuldadeAbrirBoca: 'boca-sim',
  problemaDentario: 'dentario-sim',
  usoDrogas: 'drogas-sim',
  problemaNeurologico: 'neurologico-sim',
  fumante: 'fumante-sim',
  usaDentadura: 'dentadura-sim',
  usaLentesContato: 'lentes-sim',
  usaPiercing: 'piercing-sim',
  proteseCapilar: 'protese-sim',
  possibilidadeGravidez: 'gravidez-sim',
}

export function respostaSimNaoPreenchida(value) {
  return value !== 'sim' && value !== 'nao'
}

export function obterErroValidacaoFormulario(fd) {
  if (!fd.nomeCompleto?.trim()) {
    return { message: 'O nome completo é obrigatório.' }
  }
  if (!fd.dataNascimento?.trim()) {
    return { message: 'A data de nascimento é obrigatória.' }
  }
  if (!['feminino', 'masculino', 'nao_informar'].includes(fd.sexo)) {
    return {
      message: 'Selecione uma opção de sexo (ou "Não desejo informar").',
      scrollToId: 'sexo-feminino',
    }
  }
  const idade = parseInt(String(fd.idade).trim(), 10)
  if (!Number.isFinite(idade) || idade < 1) {
    return { message: 'Informe uma idade válida (número maior ou igual a 1).' }
  }
  const peso = parseFloat(String(fd.peso).replace(',', '.'))
  if (!Number.isFinite(peso) || peso <= 0) {
    return { message: 'Informe o peso em kg (valor maior que zero).' }
  }
  const altura = parseFloat(String(fd.altura).replace(',', '.'))
  if (!Number.isFinite(altura) || altura <= 0) {
    return { message: 'Informe a altura em cm (valor maior que zero).' }
  }
  const pendentes = CAMPOS_BOOLEANOS_OBRIGATORIOS.filter((k) => {
    if (fd.sexo === 'masculino' && k === 'possibilidadeGravidez') return false
    return respostaSimNaoPreenchida(fd[k])
  })
  if (pendentes.length > 0) {
    const nomes = pendentes.slice(0, 6).map((k) => ROTULOS_CAMPO_BOOLEANO[k] || k)
    const sufixo =
      pendentes.length > 6 ? ` e mais ${pendentes.length - 6} pergunta(s)` : ''
    return {
      message: `Responda Sim ou Não em todas as perguntas obrigatórias. Pendências: ${nomes.join(', ')}${sufixo}.`,
      scrollToId: CAMPO_BOOLEANO_PARA_ID_SCROLL[pendentes[0]] || null,
      pendingField: pendentes[0],
    }
  }
  if (fd.alergicoMedicamento === 'sim' && !fd.comentario?.trim()) {
    return { message: 'Descreva suas alergias a medicamentos (obrigatório quando respondeu Sim).' }
  }
  if (fd.usoMedicamentoDiario === 'sim' && !fd.medicamentosEmUso?.trim()) {
    return { message: 'Liste os medicamentos e dose em uso (obrigatório quando respondeu Sim).' }
  }
  if (fd.usoCalmantes === 'sim' && !fd.observacoes?.trim()) {
    return { message: 'Preencha as observações sobre calmantes (obrigatório quando respondeu Sim).' }
  }
  if (fd.doencaInfectoContagiosa === 'sim' && !fd.qualDoencaInfecto?.trim()) {
    return { message: 'Especifique a doença infectocontagiosa (obrigatório quando respondeu Sim).' }
  }
  if (fd.usoDrogas === 'sim' && !fd.qualDroga?.trim()) {
    return { message: 'Especifique qual droga (obrigatório quando respondeu Sim).' }
  }
  if (fd.fumante === 'sim' && !fd.quantidadeCigarros?.trim()) {
    return { message: 'Informe a quantidade de cigarros ou maços por dia (obrigatório quando respondeu Sim).' }
  }
  if (fd.usaPiercing === 'sim' && !fd.localizacaoPiercing?.trim()) {
    return { message: 'Informe a localização do piercing (obrigatório quando respondeu Sim).' }
  }
  return null
}
